import { transformObjectValuesToObject } from '@/shared/utils/transformObjectValuesToObject';
import { ValuesOf } from '@/shared/utils/types';

const TaxProfile = {
  generalVat: 'general_vat',
  flatRate: 'flat_rate',
  belowVatRegistrationThreshold: 'below_vat',
} as const;

type TTaxProfile = ValuesOf<typeof TaxProfile>;

const taxProfileEnum = transformObjectValuesToObject(TaxProfile);

const isTaxProfileRequiresVat = (taxProfile: TTaxProfile | null | undefined): boolean =>
  taxProfile === TaxProfile.generalVat || taxProfile === TaxProfile.flatRate;

export { TaxProfile, taxProfileEnum, isTaxProfileRequiresVat };
export type { TTaxProfile };
